/* eslint-disable */

import { getVideo } from '../../fbApi/Videos';

export const reportAd = async (ad, token) => {
  switch (true) {
    case isDefined(ad.creative.object_story_spec.link_data):
      return reportLinkData(ad);
    case isDefined(ad.creative.object_story_spec.video_data):
      return await reportVideoData(ad, token);
    default:
      return '';
  }
};

const reportLinkData = (ad) => {
  let report = '';
  const linkData = ad.creative.object_story_spec.link_data;

  report += `Name: ${ad.name}\n\n`;
  report += `LINK DATA\n`;
  report += `Link: ${linkData.link}\n`;
  report += `Message: ${linkData.message}\n`;
  report += `Caption: ${linkData.caption}\n`;
  report += `\n`;

  if (linkData.call_to_action) {
    report += `CALL TO ACTION\n`;
    report += `Type: ${linkData.call_to_action.type}\n`;

    if (linkData.call_to_action.value) {
      report += `Link Caption: ${linkData.call_to_action.value.link_caption}\n`;
      report += `Link Format: ${linkData.call_to_action.value.link_format}\n`;
    }
    report += `\n`;
  }

  if (linkData.child_attachments) {
    report += `CHILD ATTACHMENTS:\n`;
    linkData.child_attachments.forEach((child, index) => {
      report += `CHILD ${index + 1}:\n`;
      report += `Link: ${child.link}\n`;
      report += `Picture: ${child.picture}\n`;
      report += `Image Hash: ${child.image_hash}\n`;
      report += `Name: ${child.name}\n`;
      report += `Description: ${child.description}\n\n`;
    });
  }

  return report;
};

const reportVideoData = async (ad, token) => {
  let report = '';
  const videoData = ad.creative.object_story_spec.video_data;

  report += `Name: ${ad.name}\n\n`;
  report += `VIDEO DATA\n`;
  report += `Title: ${videoData.title}\n`;
  report += `Message: ${videoData.message}\n`;
  report += `Image Url: ${videoData.image_url}\n`;
  report += `Image Hash: ${videoData.image_hash}\n`;
  report += `\n`;

  if (videoData.call_to_action) {
    report += `CALL TO ACTION\n`;
    report += `Type: ${videoData.call_to_action.type}\n`;

    if (videoData.call_to_action.value) {
      report += `Link Caption: ${videoData.call_to_action.value.link_caption}\n`;
      report += `Link Format: ${videoData.call_to_action.value.link_format}\n`;
    }
    report += `\n`;
  }

  if (videoData.video_id) {
    const video = await getVideo(videoData.video_id, token);

    if (video) {
      report += `VIDEO\n`;
      report += `Source: ${video.source}\n`;
      report += `Picture: ${video.picture}\n`;
    }
  }

  return report;
};

export const compareAds = (firstAd, secondAd, token) => {
  const firstCreative = firstAd.creative;
  const secondCreative = secondAd.creative;
  const firstObjectStory = firstCreative.object_story_spec;
  const secondObjectStory = secondCreative.object_story_spec;

  switch (true) {
    case isDefined(firstObjectStory.link_data) &&
      isDefined(secondObjectStory.link_data):
      return compareLinkData(firstObjectStory, secondObjectStory);
    case isDefined(firstObjectStory.video_data) &&
      isDefined(secondObjectStory.video_data):
      return compareVideoData(firstObjectStory, secondObjectStory, token);
    default:
      return false;
  }
};

const compareLinkData = (firstObjectStory, secondObjectStory) => {
  return compareObjectStoryForLinkData(
    firstObjectStory.link_data,
    secondObjectStory.link_data
  );
};

const compareVideoData = (firstObjectStory, secondObjectStory, token) => {
  return compareObjectStoryForVideoData(
    firstObjectStory.video_data,
    secondObjectStory.video_data,
    token
  );
};

const isDefined = (data) => {
  return typeof data != 'undefined' && data !== null;
};

const compareObjectStoryForVideoData = async (
  videoData1,
  videoData2,
  token
) => {
  if (
    videoData1.title !== videoData2.title ||
    videoData1.message !== videoData2.message ||
    videoData1.image_url !== videoData2.image_url ||
    videoData1.image_hash !== videoData2.image_hash
  ) {
    return false;
  }

  if (
    isDefined(videoData1.call_to_action) &&
    isDefined(videoData2.call_to_action)
  ) {
    if (
      !compareCallToAction(videoData1.call_to_action, videoData2.call_to_action)
    ) {
      return false;
    }
  } else if (
    (!isDefined(videoData1.call_to_action) &&
      isDefined(videoData2.call_to_action)) ||
    (isDefined(videoData1.call_to_action) &&
      !isDefined(videoData2.call_to_action))
  ) {
    return false;
  }

  if (isDefined(videoData1.video_id) && isDefined(videoData2.video_id)) {
    const video1 = await getVideo(videoData1.video_id, token);
    const video2 = await getVideo(videoData2.video_id, token);

    if (video1 && video2) {
      return (
        video1.source === video2.source && video1.picture === video2.picture
      );
    }
  }

  return true;
};

const compareObjectStoryForLinkData = (linkData1, linkData2) => {
  if (
    linkData1.link !== linkData2.link ||
    linkData1.message !== linkData2.message ||
    linkData1.caption !== linkData2.caption
  ) {
    return false;
  }

  if (
    isDefined(linkData1.call_to_action) &&
    isDefined(linkData2.call_to_action)
  ) {
    if (
      !compareCallToAction(linkData1.call_to_action, linkData2.call_to_action)
    ) {
      return false;
    }
  } else if (
    (!isDefined(linkData1.call_to_action) &&
      isDefined(linkData2.call_to_action)) ||
    (isDefined(linkData1.call_to_action) &&
      !isDefined(linkData2.call_to_action))
  ) {
    return false;
  }

  if (
    isDefined(linkData1.child_attachments) &&
    isDefined(linkData2.child_attachments)
  ) {
    return compareChilds(
      linkData1.child_attachments,
      linkData2.child_attachments
    );
  } else if (
    (!isDefined(linkData1.child_attachments) &&
      isDefined(linkData2.child_attachments)) ||
    (isDefined(linkData1.child_attachments) &&
      !isDefined(linkData2.child_attachments))
  ) {
    return false;
  }

  return true;
};

const compareCallToAction = (callToAction1, callToAction2) => {
  if (callToAction1.type !== callToAction2.type) {
    return false;
  }

  if (isDefined(callToAction1.value) && isDefined(callToAction2.value)) {
    return (
      callToAction1.value.link_caption === callToAction2.value.link_caption &&
      callToAction1.value.link_format === callToAction2.value.link_format
    );
  } else if (
    (!isDefined(callToAction1.value) && isDefined(callToAction2.value)) ||
    (isDefined(callToAction1.value) && !isDefined(callToAction2.value))
  ) {
    return false;
  }

  return true;
};

const compareChilds = (childs1, childs2) => {
  if (childs1.length !== childs2.length) {
    return false;
  }

  let sameChilds = true;
  childs1.forEach((child1, index) => {
    const child2 = childs2[index];
    sameChilds = sameChilds && compareChild(child1, child2);
  });

  return sameChilds;
};

const compareChild = (child1, child2) => {
  return (
    child1.link === child2.link &&
    child1.picture === child2.picture &&
    child1.image_hash === child2.image_hash &&
    child1.name === child2.name &&
    child1.description === child2.description
  );
};



// WEBPACK FOOTER //
// ./src/screens/AdComparer/AdComparerService.js